var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00464 9.39094L11.6157 15.8492C13.0973 16.9603 15.1342 16.9603 16.6157 15.8492L25.2269 9.39087",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61572 9.63654C1.61572 8.62774 2.16264 7.69824 3.04449 7.20832L12.7667 1.80708C13.6057 1.341 14.6257 1.341 15.4648 1.80708L25.187 7.20832C26.0688 7.69824 26.6157 8.62774 26.6157 9.63654V20.5021C26.6157 22.0362 25.3721 23.2799 23.8379 23.2799H4.3935C2.85938 23.2799 1.61572 22.0362 1.61572 20.5021V9.63654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTemplate);
export default __webpack_public_path__ + "static/media/Email_template.e38fb824207d4fd7b70250d85af06629.svg";
export { ForwardRef as ReactComponent };